import {Dispatch, PropsWithChildren, useReducer} from "react";
import {createKycReducer, initialCreateKycState} from "../../reducers/create-kyc";
import {createContext} from "../../../../../context/create-context";
import {CreateKycActions} from "../../reducers/create-kyc/types";

type CreateKycContextState = {
  state: typeof initialCreateKycState;
  dispatch: Dispatch<CreateKycActions>;
};

const [useContext, ContextProvider] = createContext<CreateKycContextState>();

export const useCreateKycContext = useContext;

export const CreateKycProvider = ({children}: PropsWithChildren) => {
  const [state, dispatch] = useReducer(createKycReducer, initialCreateKycState);

  return <ContextProvider value={{state, dispatch}}>{children}</ContextProvider>;
};
